import { FilterValue } from "../models/FilterValue";
import { ServerName } from "../utils/constants/serverName";
import axios from "../utils/http/axios";

export const getMonthlyReport = async () => {
  const params = new URLSearchParams();
  params.set("type", "monthlyvalues");

  return axios
    .get<[string, number | string, string, number][]>(`${ServerName}/documentreport`, {
      params: params,
    })
    .then((result) => {
      return Promise.resolve(result.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getFilterValues = async (filterType: "cases" | "documents", caseType?: string) => {
  const params = caseType ? { filterType: filterType, caseType: caseType } : { filterType: filterType };

  return axios
    .get<FilterValue[]>(`${ServerName}/filtervalues`, {
      params,
    })
    .then((result) => {
      const data = [...result.data];
      data.forEach((filterType) => {
        filterType.values.forEach((o, i, a) => {
          if (a[i] == null) {
            a[i] = "";
          }
        });
      });

      return Promise.resolve(data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
